export default "__VITE_ASSET__v2bY6BdT__"